import BaseService from "../base";
import {keycloak} from "../../keycloak/keycloak";

const apiService = new BaseService(process.env.REACT_APP_VISUALS_API_URL + '/v1/news', {});


export async function createNews(formData) {
    if (keycloak.authenticated) {
        let headers = {
            'Content-Type': 'multipart/form-data',
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.post('', formData, {headers: headers})
            .then(result => {
                return result.data
            })
            .catch(reason => {
                throw reason
            })

    }
    throw new Error('You are not authenticated')
}


export function searchNews(params) {
    if (!keycloak.authenticated) throw new Error("Not authenticated");

    const headers = {
        'Authorization': `Bearer ${keycloak.token}`,
        'Accept': 'application/json'
    };
    return apiService.get('',  params , {headers:  headers})
        .then(response => response.data)
        .catch(error => { throw error });
}



export async function updateNews(id, formData) {
    if (!keycloak.authenticated) throw new Error("Not authenticated");

    const headers = {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${keycloak.token}`,
        'Accept': 'application/json'
    };

    return await apiService.patch(`/${id}`, formData, { headers })
        .then(response => response.data)
        .catch(error => { throw error });
}


export async function deleteNews(id) {
    if (keycloak.authenticated) {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.delete(`/${id}`,{headers:headers});
    }
    throw new Error('You are not authenticated')
}